<script lang="ts">
  import { onMount } from 'svelte';

  import { Header, HeaderType } from '@shared/features';

  import { Dropzone, FilesList, LinkInfoForm } from './components';
  import { uploadFilesService } from './services';
  import { uploadingFiles } from './stores';

  onMount(() => {
    uploadFilesService.setupUppy();
  });

  $: headerProps = {
    type: $uploadingFiles.length ? HeaderType.NON_USER : HeaderType.USER,
    actionCallback: $uploadingFiles.length
      ? () => {
          uploadFilesService.resetFiles();
        }
      : () => {},
  };
</script>

<Header props={headerProps} />

<div data-component="Files" class="wrapper">
  <Dropzone />

  {#if !!$uploadingFiles.length}
    <FilesList />
    <LinkInfoForm />
  {/if}
</div>

<style src="./styles.scss"></style>
